// Separa un nombre completo en { nombre, apellido } para precargar los dos campos
// del formulario de paciente.
//
// El paciente guarda SIEMPRE el nombre completo en el campo `nombre` (así lo leen
// los turnos, las búsquedas, los PDF, etc.). Desde 2026-07 también guarda el
// `apellido` como campo propio. Con ese apellido conocido, el nombre de pila se
// obtiene RESTANDO el apellido del final del nombre completo (no se adivina).
//
// La comparación es case-insensitive a propósito: el `nombre` guardado pasó por
// capitalizarNombre() (mayúsculas + partículas en minúscula como "de la"), así que
// su sufijo puede no calzar carácter-a-carácter con el `apellido` guardado. Al bajar
// ambos a minúsculas, "...de la cruz".endsWith("de la cruz") sí calza, y el recorte
// se hace por LONGITUD sobre el string original para preservar la capitalización.
//
// Pacientes viejos (creados antes de este cambio) no tienen `apellido`: se cae al
// split por último espacio de siempre (fallback, sin regresión). En cuanto se los
// edita una vez con el formulario nuevo, quedan con `apellido` real.
export function separarNombreApellido(nombreCompleto, apellidoConocido) {
  const full = (nombreCompleto || "").trim();
  const ape = (apellidoConocido || "").trim();

  if (ape && full.toLowerCase().endsWith(ape.toLowerCase())) {
    return {
      nombre: full.slice(0, full.length - ape.length).trim(),
      apellido: ape,
    };
  }

  // Legacy: sin apellido conocido (o no calza), fallback al split por último espacio.
  const partes = full.split(" ");
  if (partes.length > 1) {
    return { nombre: partes.slice(0, -1).join(" "), apellido: partes[partes.length - 1] };
  }
  return { nombre: full, apellido: "" };
}
